import React, { useState, useEffect } from "react";
import GridTable from "@nadavshaar/react-grid-table";
import setColumns from "./setColumns.js";
import Modalv2 from "../../components/tables/Modalv2";
import ValidView from "../../components/app/validView";
import { FaAddressBook } from "react-icons/fa";
import Spinner from 'react-bootstrap/Spinner';
import ModalMultiRoles from './ModalMultiRoles';
import ModalExportExcel from "../../components/tables/ModalExportExcel";
import Button from 'react-bootstrap/Button';
import CustomHeader from "../../components/tables/CustomHeader";
import { searchUtils } from "../../components/tables/searchUtils";

const Roles = () => {
  const rowsPerPageString = process.env.REACT_APP_GRID_ROWSPERPAGE;
  const rowsPerPageArray = rowsPerPageString.split(',').map(Number);

  const nameView = "Role";
  const [isLoading, setLoading] = useState(true);
  const [rowsLoading, setRowsLoading] = useState(false);
  const [dataItem, setItem] = useState({ codeItem: 0, typeView: '', nameView: '' });
  const { allowWrite, allowView, userToken } = ValidView('Roles');

  const [objFilter, setObjFilter] = useState([]);
  const [stringFilter, setStringFilter] = useState(null);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [show_sc, setshow_sc] = useState(false);
  const handleClose_sc = () => setshow_sc(false);
  const [show_excel, setshow_excel] = useState(false);
  const handleClose_excel = () => setshow_excel(false);
  let [selectedRowsIds, setSelectedRowsIds] = useState([]);

  const modalDetail = (codeItem, typeView) => {
    setShow(true);
    setItem({ codeItem, typeView, nameView });
  };

  const modal_excel = () => {
    setshow_excel(true);
  };

  const modal_sc = (codeItem, typeView) => {
    setshow_sc(true);
    //setItem({ codeItem, typeView, nameView });
  };

  const [columnsGrid, setColumnsGrid] = useState([]);
  let [page, setPage] = useState(1);
  let [pageSize, setPageSize] = useState(rowsPerPageArray[0]);

  const changeDelay = (textSearch, tableManager, column) => {
    const { searchApi } = tableManager;
    const { searchText, setSearchText } = searchApi;
    const setSearchAndFilter = (searchText, stringFilter) => {
      setSearchText(searchText);
      setStringFilter(stringFilter);
    };
    searchUtils(textSearch, setSearchAndFilter, column, searchText, objFilter);
  };

  useEffect(() => {
    if (allowView) {
      setColumnsGrid(setColumns({ modalDetail, allowWrite, changeDelay }));
      setRowsLoading(true);
    }
  }, [allowView, allowWrite]);

  const onRowsRequest = async (requestData, tableManager) => {
    setLoading(true);
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userToken
      }
    };

    const response = await fetch(process.env.REACT_APP_NERTHUS_API_URL + '/users/roles?page=' + (page) + '&perPage=' + pageSize + requestData.searchText, requestOptions)
    .then((response) => {
      setLoading(false);
      return response.json();
    }).catch(console.warn);
    
  if (!response?.data) return;

    return {
      rows: response.data,
      totalRows: response.total_count,
    };
  };

  const OnPageChange = (event) => {
    setPage(event);
  }

  let addButton = "";
  if (allowWrite) {
    addButton = <Button size="sm" type="button" className="btn btn-success" alt="Create" onClick={() => { modalDetail(0, "Create"); }}> <FaAddressBook /> Create {nameView} </Button>;
  }

  let dataSendRoles = { 'typeView': 'View', 'codeItem': selectedRowsIds, 'nameView': 'Send Roles' };
  const urlBaseExport = '/users/roles/exportToExcel?page=1&perPage=9999';

  return (
    <>
      <div className="tableWrapper">
        {!rowsLoading
          ? (<Spinner animation="border" role="status" variant="secondary" >
            <span className="visually-hidden">Loading...</span>
          </Spinner>) : (<GridTable
            columns={columnsGrid}
            onRowsRequest={onRowsRequest}
            rowIdField={'code'}
            isLoading={isLoading}
            pageSizes={rowsPerPageArray}
            pageSize={pageSize}
            onPageSizeChange={setPageSize}
            onPageChange={OnPageChange}
            selectedRowsIds={selectedRowsIds}
            onSelectedRowsChange={setSelectedRowsIds}
            showSearch={false}
            showColumnVisibilityManager={false}
            highlightSearch={false}
            minSearchChars={3}
            components={{ Header: (props) => <CustomHeader {...props} selectedRowsIds={selectedRowsIds} allowWrite={allowWrite} modal_excel={modal_excel} modal_sc={modal_sc} setStringFilter={setStringFilter} addButton={addButton}/>  }}
          />)}
      </div>
      <Modalv2 show={show} handleClose={handleClose} dataItem={dataItem} setRenderRows={[]} />
      <ModalMultiRoles show={show_sc} handleClose={handleClose_sc} dataItem={dataSendRoles} setRenderRows={[]} />
      <ModalExportExcel show={show_excel} handleClose={handleClose_excel} objTextFind={stringFilter} urlBaseExport={urlBaseExport} nameFile={'Roles.xlsx'} />
    </>
  );
};

export default Roles;
